






















import {Component, Vue, Prop} from 'vue-property-decorator';
import {Inject} from "vue-typedi";
import {EventBus} from "@/helpers/EventBus";
import {AlertChannel, AlertService, AlertSettingsUpdateRequest} from "@/services/AlertService";
import { Zone } from '@/model/Zone';

@Component
export default class AlertPanel extends Vue {

    @Inject()
    alertService!: AlertService;

    @Prop() email: string;

    @Prop({default: {}}) zone: Zone;

    isOpened: boolean = false;
    isEditable: boolean = false;
    newEmail: string = "";

    private isEmailValidationEnabled: boolean = false;

    get storeId(): string {
        return sessionStorage.getItem("storeId");
    }

    public deleteEmail() {
        EventBus.$emit(EventBus.SHOW_DELETE_EMAIL_FORM, {email: this.email, zoneCode: this.zone.zoneCode});
    }

    public openPanel() {
        this.isOpened = true;
        this.isEditable = false;
    }

    public closePanel() {
        this.isOpened = false; 
        this.isEditable = false;
        this.isEmailValidationEnabled = false;
    }

    public modifyEmail() {
        this.isEditable = true;
        this.newEmail = this.email;
    }

    isEmailValid(): boolean {
        if (!this.isEmailValidationEnabled) {
            return true;
        }

        return this.newEmail === '' || this.newEmail.endsWith('@auchan.fr') || this.newEmail.endsWith('@partner.auchan.fr');
    }

    public validateEmail() {
        if (this.newEmail == "") {
            return;
        }
        
        this.isEmailValidationEnabled = true;
        if (!this.isEmailValid()) {
            return;
        }

        this.isEditable = false;

        const request: AlertSettingsUpdateRequest = {
            oldIdentifier: this.email,
            newIdentifier: this.newEmail,
            channel: AlertChannel.EMAIL,
            storeId: this.storeId,
            zoneCode: this.zone.zoneCode
        } as AlertSettingsUpdateRequest;

        this.alertService.updateAlert(request).then(alertSettingsList => {
            alertSettingsList.forEach(alertSettings => {
                EventBus.$emit(EventBus.REFRESH_ALERT_SETTINGS, alertSettings);
                this.isEmailValidationEnabled = false;
            });
        });
    }
}
